module.exports = __WEBPACK_EXTERNAL_MODULE_51__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","startOfToday"],"commonjs":"date-fns/start_of_today/index","commonjs2":"date-fns/start_of_today/index","amd":"date-fns/start_of_today/index"}
// module id = 51
// module chunks = 0